<!--
  Installed from https://vue-bits.dev/ui/
-->
<template>
    <div
        ref="elementRef"
        :class="className"
        :style="{
            opacity: inView ? 1 : initialOpacity,
            transition: `opacity ${duration}ms ${easing}, filter ${duration}ms ${easing}`,
            filter: blur ? (inView ? 'blur(0px)' : 'blur(10px)') : 'none',
        }"
    >
        <slot />
    </div>
</template>

<script>
export default {
    name: "FadeInOnView",
    // 定义组件接收的属性，对应原Props接口
    props: {
        // 是否启用模糊过渡效果
        blur: {
            type: Boolean,
            default: false,
        },
        // 动画过渡时长（单位：毫秒）
        duration: {
            type: Number,
            default: 1000,
        },
        // 动画缓动函数（支持CSS合法值，如ease、linear）
        easing: {
            type: String,
            default: "ease-out",
        },
        // 动画延迟执行时间（单位：毫秒）
        delay: {
            type: Number,
            default: 0,
        },
        // 触发动画的视口阈值（元素进入视口的比例，0-1之间）
        threshold: {
            type: Number,
            default: 0.1,
            validator: (val) => val >= 0 && val <= 1, // 限制阈值在合理范围
        },
        // 元素未进入视口时的初始透明度（0-1之间）
        initialOpacity: {
            type: Number,
            default: 0,
            validator: (val) => val >= 0 && val <= 1,
        },
        // 自定义外层容器类名
        className: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            inView: false, // 标记元素是否进入视口
            observer: null, // 视口检测实例（IntersectionObserver）
        };
    },
    methods: {
        // 初始化视口检测逻辑
        initIntersectionObserver() {
            const element = this.$refs.elementRef;
            if (!element) return;

            // 创建IntersectionObserver实例，监听元素是否进入视口
            this.observer = new IntersectionObserver(
                ([entry]) => {
                    // 元素进入视口时执行动画逻辑
                    if (entry.isIntersecting) {
                        this.observer.unobserve(element); // 停止监听，避免重复触发
                        // 按配置延迟切换inView状态，触发过渡动画
                        setTimeout(() => {
                            this.inView = true;
                        }, this.delay);
                    }
                },
                { threshold: this.threshold } // 按配置的阈值触发检测
            );

            // 开始监听目标元素
            this.observer.observe(element);
        },
    },
    // 组件挂载后初始化视口检测
    mounted() {
        this.initIntersectionObserver();
    },
    // 组件销毁前清理监听，避免内存泄漏
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect(); // 断开所有视口监听
        }
    },
};
</script>
